// Vendor imports
const { connect } = require('react-redux')
// Container imports
const PromoBadge = require('./component-dumb')
const promoSelectors = require('./selectors')

function mapStateToProps() {
  const promoForIdSelector = promoSelectors.createPromoForIdSelector()
  return function (state, { id, onClick }) {
    // Determine which promo to show
    const promo = (
      // If specified, prefer the promo for `ownProps.id`
      promoForIdSelector(state, id) ||
      // ...otherwise show the appropriate promo for the current browser
      promoSelectors.browserPromoSelector(state) ||
      // Fall back to the most-popular browser
      promoForIdSelector(state, 'chrome')
    )
    // Allow `ownProps.onClick` to override `promo.onClick`
    return onClick ? { ...promo, onClick } : promo
  }
}

const SmartComponent = connect(
  mapStateToProps
)(
  PromoBadge
)

module.exports = SmartComponent
